<template>
  <grid :fields="fields" :items="businesses" />
</template>

<script>
import { mapState, mapActions } from 'vuex';

import gridFields from './fields';

import Grid from '@/shared/components/Grid';

export default {
  components: {
    Grid,
  },
  data() {
    return {
      fields: gridFields,
    }
  },
  computed: {
    ...mapState('businesses', [
      'businesses',
    ]),
  },
  methods: {
    ...mapActions('businesses', [
      'getBusinesses',
    ]),
  },
  async created() {
    await this.getBusinesses();
  },
}
</script>